var SKIP_PARTNER_BASED_TAG = 'skip_partner_based';
export default function shouldSkipPartnerBased(linkTokenPayload) {
    var linkTokenTags = (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.tags) || {};
    if (SKIP_PARTNER_BASED_TAG in linkTokenTags) {
        // Link token tag values can be any type, so we're wrapping in backticks to
        // make sure we're working with a string
        var skipPartnerBasedTag = "".concat(linkTokenTags[SKIP_PARTNER_BASED_TAG]);
        if (skipPartnerBasedTag && skipPartnerBasedTag.toLowerCase() === 'true') {
            return true;
        }
    }
    return false;
}
